// REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register"
export const POST_CUSTOMER_REGISTER = "/api/users"
// GSOTP
export const GSOTP_HOST = "https://api.gsotp.com"
export const APIKEY = "d63beac1e9248a69ceffa2637f3d2901"
// LOGIN
export const POST_FAKE_LOGIN = "/post-fake-login"
export const POST_JWT_LOGIN = "/Identity/Login"
export const POST_JWT_LOGIN_BY_CODE = "/Identity/LoginByCode"
export const DELETE_JWT_SESSION = "/Identity/Logout"
export const CHANGE_PASSWORD_URL = "/Identity/ChangePassword"
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd"
export const POST_FAKE_JWT_PASSWORD_FORGET = "/Identity/ChangeToDefaultPassword"

// PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile"
export const POST_EDIT_PROFILE = "/post-fake-profile"

// CALENDER
export const GET_EVENTS = "/events"
export const ADD_NEW_EVENT = "/add/event"
export const UPDATE_EVENT = "/update/event"
export const DELETE_EVENT = "/delete/event"
export const GET_CATEGORIES = "/categories"

// CHANNELS
export const GET_CHANNELS = "/Channel/GetClientChannels"
export const GET_CHANNEL_BYID = "/Channel/GetChannelById"
export const UPSERT_CHANNEL = "/Channel/UpsertChannelMeet"
export const INSERT_CHANNEL = "/Channel"
export const DELETE_CHANNEL = "/Channel/DeleteChannel"
export const UPDATE_CHANNEL = "/Channel"
// Auction
export const ADD_CHANNEL_AUCTION = "/Channel/AddAuction"

// Users

export const GET_USERS = "/Clients/GetAllUsers"
export const INSERT_USER = "/Clients/AddUser"
export const DELETE_USER = "/clients/DeleteUser"
export const UPDATE_USER = "/clients/UpdateUser"
export const GET_USER_BALANCE = "/Users/GetUserBalance"
export const GET_USER_INFO_URL = "/Users/GetUserInfo"
export const GET_USER_FILES_URL = "/Users/GetUserFiles"
export const ADD_USER_FILE_URL = "/Users/AddFile"
export const DELETE_USER_FILE_URL = "/Users/DeleteFile"

// GasProjects
export const DELETE_GASPROJECT_FILE_URL = "/GasProjects/DeleteFile"
export const GET_GASPROJECTS_URL = "/GasProjects/GetClientGasProjects"
export const GET_GASPROJECTS_FILTER_URL =
  "/GasProjects/GetClientGasProjectsFilter"
export const GET_GASPROJECTS_FULL_FILTER_URL =
  "/GasProjects/GetClientGasProjectsFullFilter"
export const GET_GASPROJECT_REPORT_URL =
  "/GasProjects/GetClientGasProjectReport"
export const GET_GASPROJECTS_ENG_URL = "/GasProjects/GetClientGasProjectsEng"
export const UPSERT_GASPROJECT = "/GasProjects/Upsert"
export const POST_ADD_FILE_GASPROJECT = "/GasProjects/AddFile"

export const UPDATE_PROCESS_EXPERT_STAGE_URL =
  "/GasProjectProcesses/UpdateStatusExpertStageByEng"
export const UPDATE_PROCESS_MAP_STAGE_URL =
  "/GasProjectProcesses/UpdateStatusMapStageByEng"
export const UPDATE_PROCESS_DEFECT_STAGE_URL =
  "/GasProjectProcesses/UpdateStatusDefectStageByEng"

export const UPDATE_PROCESS_EXPERT_STAGE_NEW_URL =
  "/GasProjectProcesses/UpdateStatusExpertStageByEngNew"
export const UPDATE_PROCESS_MAP_STAGE_NEW_URL =
  "/GasProjectProcesses/UpdateStatusMapStageByEngNew"
export const UPDATE_PROCESS_DEFECT_STAGE_NEW_URL =
  "/GasProjectProcesses/UpdateStatusDefectStageByEngNew"

export const GET_GASPROJECT_FILES_URL = "/GasProjects/GetGasProjectFilesById"
export const GET_GASPROJECT_FREE_URL = "/Identity/GetGasProjectFree"
export const GET_GASPROJECT_INFO_PUBLIC_URL = "/GasProjects/GetGasProjectInfoPublic"
export const GET_PACKAGEINSTALLER_URL = "/GasProjects/GetPackageInstaller"
export const SEND_GASPROJECT_TOGAS_URL = "/GasProjects/Signature"
export const SEND_GASPROJECT_TOGASCO_URL = "/GasProjects/SendToCoGasCo"
export const SUBMIT_GASPROJECT_ADMIN_URL = "/GasProjects/SubmitByAdmin"
export const ADD_PACKAGE_INSTALLER_URL = "/GasProjects/AddPackageInstaller"
export const SUBMIT_PACKAGE_URL = "/Identity/SubmitPackage"
export const RESET_PACKAGE_URL = "/GasProjects/ResetPackage"
export const RESOLVED_DEFECT_URL = "/GasProjects/ResolvedDefect"
export const PREPARE_MAPSTAGE_URL = "/GasProjects/PrepareForMapStage"
export const PREPARE_FIRSTSUPERVISION_STAGE_URL = "/GasProjects/PrepareForFirstSupervisionStage"
export const PREPARE_DESIGN_STAGE_URL = "/GasProjects/PrepareForDesignStage"
export const STOP_GASPROJECT_URL = "/GasProjects/StopGasProject"
export const UPDATE_GASPROJECT_DETAILS_URL =  "/GasProjects/UpdateGasProjectDetails"
export const UPDATE_GASPROJECT_CHECKLIST_URL =  "/GasProjects/UpdateGasProjectCheckList"
export const UPDATE_GASPROJECT_URL = "/GasProjects/UpdateGasProject"
export const UPDATE_GASPROJECT_ENG_URL = "/GasProjects/UpdateGasProjectByEng"
export const DELETE_GASPROJECT_URL = "/GasProjects/DeleteGasProject"
export const  PAY_BY_EXECUTOR_WALLET_URL = "/Transactions/PayByExecutorWallet"


export const SUBMIT_DESIGN_STAGE_URL = "/GasProjectProcesses/SubmitDesignStage"
export const SUBMIT_FIRSTSUPERVISION_STAGE_URL = "/GasProjectProcesses/SubmitFirstSupervisionStage"
// Accounting Transaction
export const GET_TRANSACTION_API = "/Transactions/GetClientUserTransactions"
export const GET_BANK_TRANSACTIONS_URL = "/Transactions/GetBankTransactions"
export const RECONCILE_IRK_TRANSACTIONS_URL = "/Transactions/ReconcileIrkTransactions"
export const GET_INVOICES_API = "/Transactions/GetClientInvoices"
export const GET_ENG_INVOICES_API = "/Transactions/GetEngClientInvoices"
export const GET_ENG_INVOICE_REPORT_API =
  "/Transactions/GetClientEngInvoiceReport"
export const POST_PAYMENT_CUSTOM_URL = "/Transactions/PaymentCustom"
export const POST_ENG_PAYMENT_CUSTOM_URL = "/Transactions/EngPaymentCustom"
export const GET_ENG_WORK_URL = "/Transactions/GetClientEngWork"

// Gpp
export const GET_GPP_BYGPID_API = "/GasProjectProcesses/GetProjectProcessByGpId"
export const DEL_GPP_URL = "/GasProjectProcesses/DeleteProjectProcess"
export const PROJECT_PROCESS_URL = "/GasProjectProcesses/ProjectProcess"
export const GET_LIST_PROJECT_PROCESS_ENG_URL = "/GasProjectProcesses/GetListProjectProcessEng"
export const GET_LIST_PROJECT_PROCESS_REPORT_URL = "/GasProjectProcesses/GetListProjectProcessReport"
export const ACCEPTER_PROJECT_PROCESS_URL = "/GasProjectProcesses/AcceptedProjectProcess"

// Executors
export const UPDATE_SIGNATURE_EXECUTOR = "Executors/UpdateSignatureAttach"
export const SEND_SMS_PAYMENT_URL = "Executors/SendSmsPayment"
export const GET_LIST_EXECUTOR_URL = "Executors/GetExecutorByClient"
export const INACTIVE_EXECUTOR_URL = "Executors/InactiveExecutor"
export const UPSERT_EXECUTOR_URL = "Executors/UpsertExecutor"

// PackageInstaller
export const GET_LIST_PACKAGEINSTALLER_URL = "PackageInstallers/GetAll"
export const INACTIVE_PACKAGEINSTALLER_URL = "PackageInstallers/Inactive"
export const UPSERT_PACKAGEINSTALLER_URL = "PackageInstallers/Upsert"

// ProjectPackages
export const GET_PROJECT_PACKAGES_URL = "ProjectPackages/GetProjectPackage"
export const GET_ALL_PROJECT_PACKAGES_URL = "ProjectPackages/GetProjectPackages"
export const UPDATE_PROJECT_PACKAGE_INSTALLER_URL = "ProjectPackages/UpdateProjectPackageInstaller"
export const UPDATE_PROJECT_PACKAGE_SERIAL_URL = "ProjectPackages/UpdateProjectPackage"

// Engineer
export const GET_LIST_ENGINEER_URL = "Engineers/GetEngineerByClient"
export const UPSERT_ENGINEER_URL = "Engineers/UpsertEngineer"
export const UPSERT_ENG_HISTORY_URL = "Engineers/UpsertEngHistory"
// EngLeave endpoints
export const GET_LIST_ENG_LEAVE_URL = "Engineers/GetListEngLeave"
export const UPSERT_ENG_LEAVE_URL = "Engineers/UpsertEngLeave"
export const DELETE_ENG_LEAVE_URL = "Engineers/DeleteEngLeave"

// Quarter Tariff
export const GET_LIST_QUARTERTARIFF_URL = "QuarterTariffs/GetQuarterTariffs"
export const UPSERT_QUARTERTARIFF_URL = "QuarterTariffs/Upsert"
export const DELETE_QUARTERTARIFF_URL = "QuarterTariffs/Delete"

// Common
export const GET_FILES_COMMON_URL = "Users/GetUserFile"

// Payment melli
export const GET_PAYMENT_IPG_URL = "Transactions/PaymentMelli"
export const GET_PAYMENT_IPG_PUBLIC_URL = "Transactions/PaymentMelliPublic"

// Payment irk
export const GET_PAYMENT_IRK_URL = "Transactions/PaymentIrk"
export const GET_PAYMENT_IRK_PUBLIC_URL = "Transactions/PaymentIrkPublic"


// Support
export const GET_LIST_SUPPORT_URL = "Supports/GetSupports"
export const UPSERT_SUPPORT_URL = "Supports/Upsert"
export const CLOSED_SUPPORT_URL = "Supports/ClosedSupport"
export const SWITCH_SUPPORT_URL = "Supports/SwitchSupport"
export const GET_LIST_SUPPORT_MESSAGE_URL = "Supports/GetSupportMessages"
export const UPSERT_SUPPORT_MESSAGE_URL = "Supports/UpsertSupportMessage"
export const POST_ADD_SUPPORT_FILE_URL = "Supports/AddFile"
export const GET_SUPPORT_FILES_URL =  "Supports/GetSupportFiles"
export const DELETE_SUPPORT_FILE_URL = "/Supports/DeleteFile"


// EngPaymentList
export const UPSERT_ENG_PAYMENT_LIST_URL = "Transactions/UpsertEngPaymentList"
export const UPDATE_ENG_PAYMENT_LIST_URL = "Transactions/UpdateEngPaymentList"
export const GET_ENG_PAYMENT_LIST_URL = "Transactions/GetEngPaymentList"
export const GET_ENG_PAYMENT_TASK_URL = "Transactions/GetEngPaymentTasks"
export const ENG_PAYMENT_APPROVED_URL = "Transactions/EngPaymentApproved"

// Finance REport
export const UPSERT_FINANCE_REPORT_URL = "Finance/UpsertFinanceReport"
export const APPROVED_FINANCE_REPORT_URL = "Finance/ApprovedFinanceReport"
export const GET_FINANCE_REPORT_URL = "Finance/GetFinanceReport"
export const GET_SERVICE_REPORT_URL = "Finance/GetServiceReport"
export const GET_FINANCE_REPORT_DETAIL_LIST_URL = "Finance/GetFinanceReportDetailList"
export const UPDATE_FINANCE_REPORT_DETAIL_URL = "Finance/UpdateFinanceReportDetail"

// EngQuotaBurnList
export const GET_ENG_QUOTA_BURN_URL = "Quotas/GetEngQuotaBurnList"
export const ENG_QUOTA_BURN_APPROVED_URL = "Quotas/EngQuotaBurnApproved"
export const ENG_QUOTA_BURN_UPDATE_URL = "Quotas/EngQuotaBurnUpdate"


// Client
export const GET_CLIENT_SETTING_URL = "Clients/GetSetting"
export const INACTIVE_CLIENT_URL = "Clients/InactiveClient"
export const GET_DASHBOARD_TOKEN_URL = "MetaBase/GetDashboardToken"
export const GET_ADMIN_DASHBOARD_URL = "Dashboard/GetAdminDashboard"
export const GET_ENGINEER_DASHBOARD_URL = "Dashboard/GetEngineerDashboard"
export const GET_ENG_PAYMENT_INVOICE_URL = "Dashboard/GetEngPaymentInvoice"

// Notifications
export const GET_NOTIFICATIONS_URL = "Notifications/GetNotifications"
export const GET_UNREAD_COUNT_URL = "Notifications/GetUnreadCount"
export const ADD_NOTIFICATION_URL = "Notifications/AddNotification"
export const UPDATE_NOTIFICATION_URL = "Notifications/UpdateNotification"
export const DELETE_NOTIFICATION_URL = "Notifications/DeleteNotification"
export const MARK_NOTIFICATION_AS_SEEN_URL = "Notifications/MarkNotificationAsSeen"

// Documents
export const ADD_DOCUMENT_URL = "Documents/AddFile"
export const GET_DOCUMENT_BY_ID_URL = "Documents/GetById"
export const GET_DOCUMENTS_URL = "Documents/GetAll"
export const DELETE_DOCUMENT_URL = "Documents/DeleteFile"
export const GET_PHYSICAL_FILE_S3_URL = "Documents/GetPhysicalFileS3Liara"

// AuditLogs
export const GET_AUDIT_LOGS_BY_FILENUMBER_URL = "AuditLogs/GetByFileNumber"

// AiTraining
export const GET_AI_TRAINING_URL = "AiTraining/GetAll"
export const GET_AI_TRAINING_BY_ID_URL = "AiTraining/GetById"
export const GET_AI_TRAINING_CATEGORIES_URL = "AiTraining/GetCategories"
export const UPSERT_AI_TRAINING_URL = "AiTraining/Upsert"
export const DELETE_AI_TRAINING_URL = "AiTraining/Delete"

